import { render } from "./Number.vue?vue&type=template&id=2ac6f139&scoped=true"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"

import "./Number.vue?vue&type=style&index=0&id=2ac6f139&scoped=true&lang=css"
import "./Number.vue?vue&type=style&index=1&id=2ac6f139&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac6f139"]])

export default __exports__